import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { OrganizationNode } from "../../redux/organization";
import { allAvaliableBuildings } from "../../redux/organization/selectors";

const AvaliableNodeSelect = ({
  selectedNodePath,
  selectNode,
  prohibitToChooseBuildings,
  baseNodePath,
  includeAllBuildings,
  includeAllDepartments,
  includeAllGroups,
  strictToNode,
  selectDepart,
}: {
  selectedNodePath?: OrganizationNode[];
  selectNode: (nodeId: number) => void;
  prohibitToChooseBuildings?: boolean;
  baseNodePath: OrganizationNode[];
  includeAllBuildings?: boolean;
  includeAllDepartments?: boolean;
  includeAllGroups?: boolean;
  strictToNode?: boolean;
  selectDepart?(state: boolean): any;
}) => {
  const [openBuilding, setopenBuilding] = useState(false);
  const [openDepartments, setopenDepartments] = useState(false);
  const [openGroups, setopenGroups] = useState(false);

  const avaliableBuildings: OrganizationNode[] = useSelector(
    allAvaliableBuildings
  );
  let buildingsToChoose = avaliableBuildings;
  if (prohibitToChooseBuildings)
    buildingsToChoose = avaliableBuildings.filter(
      (el) => el.nodesTree.length > 0
    );
  if (avaliableBuildings.length === 0 && baseNodePath.length > 1)
    buildingsToChoose = [baseNodePath[0]];
  const [buildingId, setBuilding] = useState(buildingsToChoose[0]?.id);
  const currentBuildingDepartments: OrganizationNode[] =
    avaliableBuildings.length === 0
      ? [baseNodePath[1]]
      : buildingsToChoose.find((el) => el?.id === buildingId)?.nodesTree;
  const [departmentId, setDepartment] = useState(
    currentBuildingDepartments ? currentBuildingDepartments[0]?.id : 0
  );
  const handleDepartmentChange = (chosenDepartmentId: number) => {
    setDepartment(chosenDepartmentId);
    setopenDepartments(false);
    if (chosenDepartmentId === 0) {
      setGroup(0);
    } else {
      const departmentSelected = currentBuildingDepartments?.find(
        (el) => el?.id === chosenDepartmentId
      );
      const gr = departmentSelected?.nodesTree[0]
        ? departmentSelected?.nodesTree[0]?.id
        : 0;
      if (includeAllGroups && departmentSelected.nodesTree.length > 0)
        setGroup(0);
      else setGroup(gr);
    }
  };
  const handleBuildingChange = (buildingId: number) => {
    setBuilding(buildingId);
    setopenBuilding(false);
    if (buildingId === 0) {
      setDepartment(0);
      setGroup(0);
    } else {
      const newBuilding = avaliableBuildings.find(
        (el) => el?.id === buildingId
      );
      if (includeAllDepartments && newBuilding?.nodesTree?.length > 0)
        setDepartment(0);
      else setDepartment(newBuilding?.nodesTree[0]?.id || 0);
      const gr = newBuilding?.nodesTree[0]?.id
        ? newBuilding?.nodesTree[0]?.nodesTree[0]?.id
        : 0;
      includeAllGroups ? setGroup(0) : setGroup(gr);
    }
  };
  const departmentSelected = currentBuildingDepartments?.find(
    (el) => el?.id === departmentId
  );

  const currentDepartmentGroups: OrganizationNode[] =
    avaliableBuildings.length === 0 && baseNodePath[2] !== undefined
      ? [baseNodePath[2]]
      : departmentSelected !== undefined
      ? departmentSelected.nodesTree
      : [];

  const [groupId, setGroup] = useState(currentDepartmentGroups[0]?.id);
  const handleGroupChange = (chosenGroupId: number) => {
    setGroup(chosenGroupId);
    setopenGroups(false);
  };

  useEffect(() => {
    if (selectedNodePath !== undefined) {
      if (!strictToNode) {
        if (selectedNodePath[0] !== undefined) {
          if (includeAllBuildings) setBuilding(0);
          else setBuilding(selectedNodePath[0]?.id);
        } else if (includeAllBuildings) setBuilding(0);
        if (selectedNodePath[1] !== undefined) {
          if (includeAllDepartments) setDepartment(0);
          else setDepartment(selectedNodePath[1]?.id);
        } else if (includeAllDepartments) setDepartment(0);
        if (selectedNodePath[2] !== undefined) {
          if (includeAllGroups) setGroup(0);
          else setGroup(selectedNodePath[2]?.id);
        } else if (includeAllGroups) setGroup(0);
      } else {
        //reverse, more important to set actual node, otherwise - first one
        if (selectedNodePath[0] !== undefined)
          setBuilding(selectedNodePath[0]?.id);
        else if (includeAllBuildings) setBuilding(0);
        if (selectedNodePath[1] !== undefined)
          setDepartment(selectedNodePath[1]?.id);
        else if (includeAllDepartments) setDepartment(0);
        if (selectedNodePath[2] !== undefined)
          setGroup(selectedNodePath[2]?.id);
        else if (includeAllGroups) setGroup(0);
      }
    }
  }, [
    includeAllBuildings,
    includeAllDepartments,
    includeAllGroups,
    selectedNodePath,
    strictToNode,
  ]);

  useEffect(() => {
    const targetNodeId =
      groupId !== 0 && groupId !== undefined
        ? groupId
        : departmentId !== 0 && departmentId !== undefined
        ? departmentId
        : buildingId;
    if (selectNode) selectNode(targetNodeId);
  }, [groupId, departmentId, buildingId, selectNode]);

  const tCommon = useTranslation("common").t;

  useEffect(() => {
    if (openBuilding) {
      selectDepart(true);
    } else {
      selectDepart(false);
    }
  }, [openDepartments, openGroups, openBuilding]);

  const onOpenDepartments = useCallback(() => {
    // selectDepart();
    if (!openDepartments) {
      setopenDepartments(true);
      setopenGroups(false);
      setopenBuilding(false);
    } else {
      setopenDepartments(false);
    }
  }, [openDepartments]);
  const onOpenGroups = useCallback(() => {
    // selectDepart();
    if (!openGroups) {
      setopenGroups(true);
      setopenBuilding(false);
      setopenDepartments(false);
    } else setopenGroups(false);
  }, [openGroups]);
  const onOpenBuildings = useCallback(() => {
    // selectDepart();
    if (!openBuilding) {
      setopenBuilding(true);
      setopenDepartments(false);
      setopenGroups(false);
    } else setopenBuilding(false);
  }, [openBuilding]);

  return (
    <>
      {/* Building */}
      <div className="text-icons" onClick={onOpenBuildings}>
        <i className="icon-brdc-court" />
        <div className="truncated-text">
          {buildingsToChoose?.find((el) => el.id === buildingId)?.title}
        </div>
      </div>
      {openBuilding &&
        buildingsToChoose.map((bel) => (
          <div
            className={`text-icons`} // ${buildingId === bel.id ? "selected" : ""}
            style={{ color: buildingId === bel.id ? "black" : "" }}
            onClick={() => handleBuildingChange(bel.id)}
            key={bel.id}
          >
            <i className="icon-empty" />
            <div
              className={`truncated-text ${
                buildingId === bel.id ? "selected" : ""
              }`}
            >
              {bel?.title}
            </div>
          </div>
        ))}
      {/* Department */}
      <div className="text-icons" onClick={onOpenDepartments}>
        <i className="icon-brdc-hospital" />
        <div className="truncated-text">
          {currentBuildingDepartments?.find((el) => el.id === departmentId)
            ?.title || tCommon("labels.allDepart")}
        </div>
      </div>
      {openDepartments &&
        currentBuildingDepartments.length > 0 &&
        includeAllDepartments && (
          <div
            className={`text-icons`} //${departmentId === 0 ? "selected" : ""}
            style={{ color: departmentId === 0 ? "black" : "" }}
            onClick={() => handleDepartmentChange(0)}
          >
            <i className="icon-empty" />
            <div
              className={`truncated-text ${
                departmentId === 0 ? "selected" : ""
              }`}
            >
              {tCommon("labels.allDepart")}
            </div>
          </div>
        )}
      {openDepartments &&
        currentBuildingDepartments?.map((bel) => (
          <div
            className={`text-icons`} //departmentId === bel.id ? "selected" : ""
            style={{ color: departmentId === bel.id ? "black" : "" }}
            onClick={() => handleDepartmentChange(bel.id)}
            key={bel.id}
          >
            <i className="icon-empty" />
            <div
              className={`truncated-text ${
                departmentId === bel.id ? "selected" : ""
              }`}
            >
              {bel?.title}
            </div>
          </div>
        ))}
      {/* Group */}
      {departmentId !== 0 && (
        <>
          <div className="text-icons" onClick={onOpenGroups}>
            <i className="icon-brdc-groups" />
            <div className="truncated-text">
              {currentDepartmentGroups?.find((el) => el.id === groupId)
                ?.title || tCommon("labels.allGroups")}
            </div>
          </div>
          {openGroups &&
            currentDepartmentGroups.length > 0 &&
            includeAllGroups && (
              <div
                className={`text-icons`} // ${groupId === 0 ? "selected" : ""}
                style={{ color: groupId === 0 ? "black" : "" }}
                onClick={() => handleGroupChange(0)}
              >
                <i className="icon-empty" />
                <div className="truncated-text">
                  {tCommon("labels.allGroups")}
                </div>
              </div>
            )}
          {openGroups &&
            currentDepartmentGroups?.map((bel) => (
              <div
                className={`text-icons`} // ${groupId === bel.id ? "selected" : ""}
                style={{ color: groupId === bel.id ? "black" : "" }}
                onClick={() => handleGroupChange(bel.id)}
                key={bel.id}
              >
                <i className="icon-empty" />
                <div
                  className={`truncated-text ${
                    groupId === bel.id ? "selected" : ""
                  }`}
                >
                  {bel?.title}
                </div>
              </div>
            ))}
        </>
      )}
    </>
  );
};
export default React.memo(AvaliableNodeSelect);
